var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "xl:mt-1/20 lg:mt-auto"
  }, [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('illustration', {
    attrs: {
      "name": "error404"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center mt-15"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Revenir à l'accueil",
      "uppercase": true,
      "icon": "home",
      "enable-action": false
    }
  })], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }